import { render } from "./_MultiselectWrapperLegado.vue?vue&type=template&id=980a7a16"
import script from "./_MultiselectWrapperLegado.vue?vue&type=script&lang=js"
export * from "./_MultiselectWrapperLegado.vue?vue&type=script&lang=js"

import "./_MultiselectWrapperLegado.vue?vue&type=style&index=0&id=980a7a16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/selectors/_MultiselectWrapperLegado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "980a7a16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('980a7a16', __exports__)) {
    api.reload('980a7a16', __exports__)
  }
  
  module.hot.accept("./_MultiselectWrapperLegado.vue?vue&type=template&id=980a7a16", () => {
    api.rerender('980a7a16', render)
  })

}


export default __exports__